import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import useGetChangeBranchPostFix from 'api/productDetail/useGetChangeBranchPostFix/useGetChangeBranchPostFix';
import useSetChangeBranchPostFix from 'api/productDetail/useSetChangeBranchPostFix/useSetChangeBranchPostFix';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import React, { useEffect, useState } from 'react';

const BranchPathfixModal = ({ open, handleClose, branchGuid }) => {
  const [pathfixValue, setPathfixValue] = useState('');

  const [getBranchPostFix, getLoading] = useGetChangeBranchPostFix();
  const [setBranchPostFix, setLoading] = useSetChangeBranchPostFix();

  useEffect(() => {
    getBranchPostFix(branchGuid, setPathfixValue);
  }, []);

  const onClose = () => {
    handleClose();
    setPathfixValue('');
  };

  const submitCodeGroup = () => {
    setBranchPostFix(branchGuid, pathfixValue, () => onClose());
  };

  return (
    <Dialog open={open} onClose={onClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ثبت پسوند</DialogTitle>

      {getLoading ? (
        <SpinnerLoader />
      ) : (
        <DialogContent>
          <FilledWrapper>
            <FilledLabel>پسوند</FilledLabel>
            <TextField
              variant="standard"
              value={pathfixValue}
              onChange={e => setPathfixValue(e.target.value)}
              sx={{ minWidth: 300 }}
            />
          </FilledWrapper>
        </DialogContent>
      )}

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button onClick={onClose} variant="contained" disabled={setLoading}>
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={submitCodeGroup}
          loading={setLoading}
        >
          اعمال
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BranchPathfixModal;

const FilledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const FilledLabel = styled.label``;
